import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

const IntegrationCardContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      css={{
        backgroundColor: 'background.surface',
        borderRadius: 'medium',
        color: 'text',
        p: 'space.300',
        boxShadow: 'xs',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        minWidth: '272px',
      }}
    >
      {children}
    </Box>
  );
};

export default IntegrationCardContainer;
